import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import AdminToast from "../../../core/admin/adminToast";
import AdminButton from "../../../core/admin/adminButton";
import AdminField, { AdminTextarea } from "../../../core/admin/adminField";
import AdminTextInput from "../../../core/admin/adminTextInput";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../../firebase";

export default function CreateFAQModal({ close, finish }: { close: () => void, finish: () => void }) {

    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [loading, setLoading] = useState(false);
    const [badToast, setBadToast] = useState(false);

    const createFaq = async () => {
        try {
            if (!question || !answer) {
                return null;
            }
            setLoading(true);
            await addDoc(collection(db, "faqs"), {
                question,
                answer,
                display: false,
                order: 0
            });
            finish();
        } catch (error) {
            console.log(error);
            setBadToast(true);
        } finally {
            setLoading(false);
        }
    }

    const handleQuestion = (e: string) => {
        if (e.length < 152) {
            setQuestion(e);
        }
    }

    const handleAnswer = (e: string) => {
        if (e.length < 500) {
            setAnswer(e);
        }
    }

    return (
        <AdminModal
            close={close}
            title="Nova FAQ"
            subtitle="A FAQ é criada oculta — ative a visibilidade na lista quando quiser publicá-la."
            footer={
                <>
                    <AdminButton variant="secondary" disabled={loading} onClick={close}>Cancelar</AdminButton>
                    <AdminButton loading={loading} disabled={!question || !answer} onClick={createFaq} className="sm:min-w-[120px]">Criar</AdminButton>
                </>
            }
        >
            <div className="flex flex-col gap-4">
                <AdminField label="Pergunta" htmlFor="new-faq-question" required counter={{ current: question.length, max: 151 }}>
                    <AdminTextInput id="new-faq-question" disabled={loading} value={question} onChange={e => handleQuestion(e.target.value)} placeholder="Ex.: Como funciona a compra segura?" />
                </AdminField>
                <AdminField label="Resposta" htmlFor="new-faq-answer" required counter={{ current: answer.length, max: 499 }}>
                    <AdminTextarea id="new-faq-answer" rows={6} disabled={loading} value={answer} onChange={e => handleAnswer(e.target.value)} />
                </AdminField>
            </div>
            <AdminToast toast={badToast} setToast={setBadToast} tone="danger" message="Erro!" />
        </AdminModal>
    )
}
